import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../../../components/unauthorizeHandler";

export function* handleFetchImsDistribution({ data }) {
  const { search, id, ...rest } = data;

  Object.keys(search).forEach((key) => {
    if (search[key]?.length < 1 || search[key] === null) delete search[key];
  });

  try {
    const response = yield axios.get(
      `${baseURL}/api/v2/document_control/${id}/distributions`,
      {
        params: { ...rest, ...(Object.keys(search).length > 0 && { search }) },
      }
    );
    const { success } = response.data;

    if (success) {
      yield put(actions.fetchImsDistributionSuccess(response.data.data));
    } else if (!success) {
      yield put(actions.fetchImsDistributionError());
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchImsDistributionError());
    console.log(error);
  }
}

export function* handleCreateImsDistribution({ data }) {
  const fd = new FormData();
  const { parentRecordID, ...rest } = data;
  for (const [key, value] of Object.entries(rest)) {
    if (key === "images" && value !== undefined && value !== null) {
      Array.from(value).forEach((image) => {
        fd.append(`attachments[]`, image);
      });
    } else if (value !== null && value !== undefined) {
      fd.append(key, value);
    }
  }

  try {
    const response = yield axios.post(
      `${baseURL}/api/v2/document_control/${parentRecordID}/distributions`,
      fd,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.createImsDistributionSuccess(response.data.data));
    } else if (!success) {
      AntdAlert.error(response.data?.errors[0]);
      yield put(actions.createImsDistributionError());
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.createImsDistributionError());
    AntdAlert.error("Something went wrong!");
  }
}

export function* handleUpdateImsDistribution({ data }) {
  const { id, parentRecordID, ...res } = data;

  const fd = new FormData();
  for (const [key, value] of Object.entries(res)) {
    if (key === "images" && value !== undefined && value !== null) {
      Array.from(value).forEach((image) => {
        const { isLocal } = image;
        if (isLocal) {
          fd.append(`attachments[]`, image);
        }
        // else fd.append("image_ids[]", key);
      });
    } else if (value !== null && value !== undefined) {
      fd.append(key, value);
    }
  }

  try {
    const response = yield axios.patch(
      `${baseURL}/api/v2/document_control/${parentRecordID}/distributions/${id}`,
      fd,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateImsDistributionSuccess(response.data.data));
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.updateImsDistributionError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateImsDistributionError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteImsDistribution({ data }) {
  const { parentRecordID, id, onDeleteSuccess } = data;
  try {
    const response = yield axios.delete(
      `${baseURL}/api/v2/document_control/${parentRecordID}/distributions/${id}`
    );
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.deleteImsDistributionSuccess(response.data.data));
      onDeleteSuccess();
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.deleteImsDistributionError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteImsDistributionError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteImsDistributionAttach({ data }) {
  const { key, recordId, parentRecordID } = data;

  let params = {
    id: key,
  };

  try {
    const response = yield axios.delete(
      `${baseURL}/api/v2/document_control/${parentRecordID}/distributions/delete_distribution_attachment`,
      {
        params,
      }
    );
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(
        actions.deleteImsDistributionAttachSuccess({
          recordId,
          imgItem: response.data.data,
        })
      );
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.deleteImsDistributionAttachError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteImsDistributionAttachError(response.data.data));
    AntdAlert.error("Something went wrong!");
  }
}

export function* handleAddImsDistributionAttach({ data }) {
  const { setCurrentUpdateObj } = data;

  const { id, images, parentRecordID } = data.data;

  const fd = new FormData();
  Array.from(images).forEach((image) => {
    const { isLocal } = image;
    if (isLocal) {
      fd.append(`attachments[]`, image);
    }
  });

  try {
    const response = yield axios.patch(
      `${baseURL}/api/v2/document_control/${parentRecordID}/distributions/${id}`,
      fd,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateImsDistributionSuccess(response.data.data));
      setCurrentUpdateObj(response.data.data);
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.updateImsDistributionError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateImsDistributionError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}
